import { AssetReport, UpdateAssetReportRequest } from '../type/AssetReport.type';
import axios from 'axios';
import { LOCALFORAGE_YN, SERVER_URL } from '../../../common/comstant/CommonConstants';
import { useAssetReportStore } from '../store/AssetReport.localforage';

export const useAssetReportAPI = () => {
  const { insertAssetReportToStore, getAssetReportListFromStore, updateAssetReportAtStore, deleteAssetReportAtStore } =
    useAssetReportStore();

  const insertAssetReport = async (assetReport: AssetReport) => {
    if (LOCALFORAGE_YN) {
      return insertAssetReportToStore(assetReport);
    } else {
      return axios.post<string>(`${SERVER_URL}/asset-report`, assetReport);
    }
  };

  const getAssetReportList = async () => {
    if (LOCALFORAGE_YN) {
      return getAssetReportListFromStore();
    } else {
      return axios.get<AssetReport[]>(`${SERVER_URL}/asset-report`);
    }
  };

  const updateAssetReport = async (id: string, updateAssetReportRequest: UpdateAssetReportRequest) => {
    if (LOCALFORAGE_YN) {
      return updateAssetReportAtStore(id, updateAssetReportRequest);
    } else {
      return axios.put<string>(`${SERVER_URL}/asset-report/${id}`, updateAssetReportRequest);
    }
  };

  const deleteAssetReport = async (id: string) => {
    if (LOCALFORAGE_YN) {
      return deleteAssetReportAtStore(id);
    } else {
      return axios.delete<AssetReport>(`${SERVER_URL}/asset-report/${id}`);
    }
  };

  return {
    insertAssetReport,
    getAssetReportList,
    updateAssetReport,
    deleteAssetReport,
  };
};
